import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';
import { HttpResponse } from '@/interfaces';

interface ContactFormData {
	subject: string;
	message: string;
}

class ContactFormService {
	constructor(private client: AxiosInstance) {}

	async submit(data: ContactFormData): Promise<HttpResponse<any>> {
		return this.client.post('/contact-us/customer-support', data);
	}
}

export const contactFormService = new ContactFormService(axiosClient);
